import React from 'react';
import loadable from '@loadable/component';

const Animation = loadable(
  () => import(/* webpackChunkName: "Animation.loadable" */ 'app/shared/modules/Animation/component'),
);

export type AnimationProps = {
  className?: string;
  animationData: Record<string, unknown>;
  shouldLoop?: boolean;
  shouldAutoplay?: boolean;
  isInteractive?: boolean;
  playTimer?: number;
  shouldUseLastFrame?: boolean;
  isPlaying?: boolean;
};

const LoadableAnimation = (props: AnimationProps) => {
  return <Animation {...props} />;
};

export default LoadableAnimation;
